import { render, staticRenderFns } from "./ProjectChoiceSettingsPreview.vue?vue&type=template&id=47bf1930&scoped=true&"
import script from "./ProjectChoiceSettingsPreview.vue?vue&type=script&lang=js&"
export * from "./ProjectChoiceSettingsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bf1930",
  null
  
)

export default component.exports